import CompareExtent from '@/components/compare-extent';
/* eslint-disable no-alert */
import '~/sass/pages/compare.scss';

const { $ } = window;

function initCompare() {
  const createCompare = new CompareExtent();
  console.log(createCompare.isConstructor);
}

function checkLargeViewSize() {
  return window.innerWidth >= 1024;
}

function updateCompareLastColumn() {
  const compareTable = $('.table-compare');

  if (compareTable.length === 0) {
    return;
  }

  const compareRows = $('.compare-row');

  compareRows.each((index, element) => {
    const lastCol = $(element).children().last();

    if (checkLargeViewSize() === true) {
      lastCol.css('display', '');
    } else {
      console.log('hide last col');
      lastCol.css('display', 'none');
    }
  });
}

function updateLimitBottom() {
  return $('#compare-footer').position().top;
}

$(document).ready(() => {
  let isLargeView = checkLargeViewSize();
  let limitBottom = updateLimitBottom();
  let scrollFixedBarInited = false;
  let maxSelectCarLength = isLargeView ? 3 : 2;
  updateCompareLastColumn();
  initCompare();
  function initScrollFixedCompareBar() {
    $('#compare-footer').scrollToFixed({
      bottom: 0,
      zIndex: 9980,
      limit() {
        return limitBottom;
      },
    });
  }

  function destroyScrollFixedCompareBar() {
    if ($.isScrollToFixed('#compare-footer')) {
      $('#compare-footer').trigger('detach.ScrollToFixed');
      scrollFixedBarInited = false;
    }
  }

  function reInitScrollFixedCompareBar() {
    destroyScrollFixedCompareBar();
    limitBottom = updateLimitBottom();
    initScrollFixedCompareBar(limitBottom);
  }

  $(window).resize(() => {
    isLargeView = checkLargeViewSize();
    limitBottom = updateLimitBottom();
    maxSelectCarLength = isLargeView ? 3 : 2;
    updateCompareLastColumn();
  });

  $('#compareSpecification, #compareOutward, #compareInterior, #compareSafety, #compareTechnology').on('shown.bs.collapse', () => {
    reInitScrollFixedCompareBar();
  });

  $('#compareSpecification, #compareOutward, #compareInterior, #compareSafety, #compareTechnology').on('hidden.bs.collapse', () => {
    reInitScrollFixedCompareBar();
  });

  $('#sectionSelectCar, #sectionCompareTable').on('click', '.select-car-button', (event) => {
    event.preventDefault();
    $.fancybox.open({
      src: '#selectCarModal',
      type: 'inline',
      baseClass: 'fancybox-container-fullscreen',
      touch: false,
    });
  });

  $('.select-car-list-wrap .row').on('change', 'input[name="selectCar"]', () => {
    const checkedLength = $('input[name="selectCar"]:checked').length;

    $('[data-fancybox-confirm-select]').attr('disabled', checkedLength < 1 || checkedLength > maxSelectCarLength);
  });

  $('[data-fancybox-confirm-select]').on('click', (event) => {
    event.preventDefault();
    const checkedItems = $('input[name="selectCar"]:checked');

    // if (checkedItems.length < 2) {
    //   window.alert('請至少選擇兩輛車！');
    //   return;
    // }

    if (checkedItems.length > maxSelectCarLength) {
      if (isLargeView === true) {
        window.alert('至多選擇兩輛車！');
      } else {
        window.alert('行動裝置瀏覽最多可一次比較兩輛車，若需比較三輛車，請以電腦裝置瀏覽。');
      }
      return;
    }

    $.fancybox.close();

    if ($('#sectionCompareTable').css('display') === 'none') {
      $('#sectionSelectCar').hide();
      $('#sectionCompareTable').show();

      setTimeout(() => {
        limitBottom = updateLimitBottom();
        updateCompareLastColumn();
        if (scrollFixedBarInited === false) {
          initScrollFixedCompareBar(limitBottom);
          scrollFixedBarInited = true;
        }
      }, 500);
    }
  });
});
